import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Accordion, AccordionDetails, AccordionSummary, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';

class QuestionList extends Component {

    constructor(props){
		super(props)
		this.state = {
			expanded: this.props.expand
		}

		this.toggleClick = this.toggleClick.bind(this)
	}
	
	toggleClick(){
		this.setState({
			expanded: !this.state.expanded
		})
	}

	componentDidUpdate(prevProps){
		if(this.props.expand !== prevProps.expand){
			this.setState({
				expanded: this.props.expand
			})
		}
	}


    render() {
		let counter = 0;
        let questions = this.props.content.Data[0].QuestionSets.map(questionSet => {
            if(questionSet.Visibility == "1" && questionSet.Questions.length > 1){
				//this is the group

				let returnItem = []
				
				let alphaCounter = '`'
				
				counter++;

				returnItem.push(<TableRow>
									<TableCell style={{width:"85%"}}>{counter}.  {questionSet.QuestionSet}</TableCell>
									<TableCell style={{width:"15%", backgroundColor:"#d4d4d4"}}></TableCell>
								</TableRow>)
				returnItem.push(questionSet.Questions.map(question => {
					if(question.Visibility == "1"){
						alphaCounter = String.fromCharCode(alphaCounter.charCodeAt(0) + 1)
						return <TableRow>
							<TableCell style={{width:"85%", paddingLeft:'35px'}}>    {alphaCounter}.  {question.Question}</TableCell>
							<TableCell style={{width:"15%", backgroundColor:"#d4d4d4"}}>{question.Answer}</TableCell>
						</TableRow>
					}
				}))
				return returnItem
			} else {
				if(questionSet.Visibility == "1"){
					counter++;
					return <TableRow>
							<TableCell style={{width:"85%"}}>{counter}.  {questionSet.Questions[0].Question}</TableCell>
							<TableCell style={{width:"15%", backgroundColor:"#d4d4d4"}}>{questionSet.Questions[0].Answer}</TableCell>
						</TableRow>
				}
				
			}
			
        })

        return(
            <Grid style={{textAlign:'left', marginTop:'20px', marginBottom:'20px'}}>
                <Accordion id="questionAccordion" expanded={this.state.expanded} onChange={this.toggleClick}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography variant="h6">{this.props.content.Header}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography>{this.props.content.Subheader}</Typography>
                            </Grid>
                            <Grid container xs={12}>
                                <Table>
                                    
									<TableBody>
											{questions}
									</TableBody>
                                </Table>
                            </Grid>
                        </Grid>

                        
                        
                    </AccordionDetails>
                </Accordion>
            </Grid>
        )
    }
}

export default QuestionList

/*<TableHead>
										<ol>
											<TableRow>
                                            <TableCell style={{width:"85%"}}>{this.props.content.Questions}</TableCell>
                                            <TableCell style={{width:"15%", backgroundColor:"#d4d4d4"}}>{this.props.content.Answers}</TableCell>
                                        	</TableRow>
										</ol>
                                        
                                    </TableHead> */
/*
{
	"ComponentClass": "DATA",
	"ComponentFamily": "QUESTIONS",
	"ComponentType": "ACCORDION",
	"ComponentContent": {
		"Data": [
			{
				"QuestionSet": "",
				"QuestionSet": "TGT 27A0024 ADULT",
				"ShowHeader": "0",
				"Visibility": "1",
				"QuestionSets": [
					{
						"QuestionSet": "",
						"QuestionSetName": "TGT 27A0024 DATE OF BIRTH",
						"ShowHeader": "0",
						"Visibility": "1",
						"Questions": [
							{
								"Question": "What is your birth date?",
								"Prompt": "",
								"Answer": "6-12-1991",
								"Visiblity": "1"
							}
						]
					},
					{
						"QuestionSet": "",
						"QuestionSetName": "TGT 27A0024 AGE",
						"ShowHeader": "0",
						"Visibility": "0"
					},
					{
						"QuestionSet": "",
						"QuestionSetName": "TGT 27A0024 HEIGHT",
						"ShowHeader": "0",
						"Visibility": "1",
						"Questions": [
							{
								"Question": "What is your height?",
								"Prompt": "inches",
								"Answer": "69",
								"Visiblity": "1"
							}
						]
					},
					{
						"QuestionSet": "",
						"QuestionSetName": "TGT 27A0024 WEIGHT",
						"ShowHeader": "0",
						"Visibility": "1",
						"Questions": [
							{
								"Question": "What is your weight?",
								"Prompt": "pounds",
								"Answer": "180",
								"Visiblity": "1"
							}
						]
					},
					{
						"QuestionSet": "",
						"QuestionSetName": "TGT 27A0024 BODY MASS INDEX",
						"ShowHeader": "0",
						"Visibility": "0"
					},
					{
						"QuestionSet": "",
						"QuestionSetName": "TGT 27A0024 AGE AT MENARCHE",
						"ShowHeader": "0",
						"Visibility": "1",
						"Questions": [
							{
								"Question": "How old were you when you had your first menstrual period?",
								"Prompt": "",
								"Answer": "Under age 12 years",
								"Visiblity": "1"
							}
						]
					},
					{
						"QuestionSet": "",
						"QuestionSetName": "TGT 27A0024 HAS GIVEN BIRTH",
						"ShowHeader": "0",
						"Visibility": "1",
						"Questions": [
							{
								"Question": "Have you given birth to a child?",
								"Prompt": "",
								"Answer": "No",
								"Visiblity": "1"
							}
						]
					},
					{
						"QuestionSet": "",
						"QuestionSetName": "TGT 27A0024 AGE FIRST LIVE BIRTH",
						"ShowHeader": "0",
						"Visibility": "0"
					},
					{
						"QuestionSet": "",
						"QuestionSetName": "TGT 27A0024 DENSE BREASTS",
						"ShowHeader": "0",
						"Visibility": "1",
						"Questions": [
							{
								"Question": "Has a doctor ever told you that you have dense breasts?",
								"Prompt": "",
								"Answer": "No",
								"Visiblity": "1"
							}
						]
					},
					{
						"QuestionSet": "",
						"QuestionSetName": "TGT 27A0024 HISTORY OF BREAST CANCER",
						"ShowHeader": "0",
						"Visibility": "1",
						"Questions": [
							{
								"Question": "Has a doctor ever told you that you have breast cancer including carcinoma in situ?",
								"Prompt": "",
								"Answer": "Yes",
								"Visiblity": "1"
							}
						]
					},
					{
						"QuestionSet": "",
						"QuestionSetName": "TGT 27A0024 HAD BREAST BIOPSY",
						"ShowHeader": "0",
						"Visibility": "1",
						"Questions": [
							{
								"Question": "Have you ever had a breast biopsy?",
								"Prompt": "",
								"Answer": "No",
								"Visiblity": "1"
							}
						]
					},
					{
						"QuestionSet": "",
						"QuestionSetName": "TGT 27A0024 BENIGN BREAST BIOPSY",
						"ShowHeader": "0",
						"Visibility": "0"
					},
					{
						"QuestionSet": "",
						"QuestionSetName": "TGT 27A0024 NUMBER OF BENIGN BREAST BIOPSIES",
						"ShowHeader": "0",
						"Visibility": "0"
					},
					{
						"QuestionSet": "",
						"QuestionSetName": "TGT 27A0024 HISTORY OF ATYPICAL HYPERPLASIA",
						"ShowHeader": "0",
						"Visibility": "0"
					},
					{
						"QuestionSet": "",
						"QuestionSetName": "TGT 27A0024 NUMBER OF BREAST CANCERS IN FAMILY",
						"ShowHeader": "0",
						"Visibility": "1",
						"Questions": [
							{
								"Question": "How many of your first-degree relatives (mother, sisters, daughters) have had breast cancer?",
								"Prompt": "",
								"Answer": "One",
								"Visiblity": "1"
							}
						]
					},
					{
						"QuestionSet": "",
						"QuestionSetName": "TGT 27A0024 BRCA GENE TEST",
						"ShowHeader": "0",
						"Visibility": "1",
						"Questions": [
							{
								"Question": "Have you ever been tested for BRCA1/2 gene mutation?",
								"Prompt": "",
								"Answer": "Never tested",
								"Visiblity": "1"
							}
						]
					},
					{
						"QuestionSet": "",
						"QuestionSetName": "TGT 27A0024 BRCA MUTATION IN FAMILY",
						"ShowHeader": "0",
						"Visibility": "1",
						"Questions": [
							{
								"Question": "Do you have a first degree relative with BRCA1/2 gene mutation?",
								"Prompt": "",
								"Answer": "No",
								"Visiblity": "1"
							}
						]
					},
					{
						"QuestionSet": "",
						"QuestionSetName": "TGT 27A0024 HAS OTHER GENETIC RISKS",
						"ShowHeader": "0",
						"Visibility": "1",
						"Questions": [
							{
								"Question": "Has a doctor ever told you that you have Li-Fraumeni syndrome, Cowden syndrome, or Ruvalcaba syndrome?",
								"Prompt": "",
								"Answer": "No",
								"Visiblity": "1"
							}
						]
					},
					{
						"QuestionSet": "",
						"QuestionSetName": "TGT 27A0024 OTHER GENETIC RISKS IN FAMILY",
						"ShowHeader": "0",
						"Visibility": "1",
						"Questions": [
							{
								"Question": "Do you have a first degree relative with Li-Fraumeni syndrome, Cowden syndrome, or Bannayan-Riley-Ruvalcaba syndrome?",
								"Prompt": "",
								"Answer": "No",
								"Visiblity": "1"
							}
						]
					},
					{
						"QuestionSet": "",
						"QuestionSetName": "TGT 27A0024 HAD RADIATION THERAPY TO CHEST",
						"ShowHeader": "0",
						"Visibility": "1",
						"Questions": [
							{
								"Question": "Did you ever have radiation therapy to the chest when you were between ages 10 and 30 years old?",
								"Prompt": "",
								"Answer": "No",
								"Visiblity": "1"
							}
						]
					},
					{
						"QuestionSet": "",
						"QuestionSetName": "TGT 27A0024 RACE GAIL MODEL",
						"ShowHeader": "0",
						"Visibility": "1",
						"Questions": [
							{
								"Question": "Which of the following best describes you?",
								"Prompt": "",
								"Answer": "White",
								"Visiblity": "1"
							}
						]
					}
				]
			}
		],
		"Header": "Your answers",
		"Subheader": "These results are based upon how you answered the following questions:",
		"IsCollapsed": "1",
        "CanCollapse": "1",
        "Questions": "Questions",
        "Answers": "Answers"
	},
	"ComponentVisible": "1"
}
*/